/**
 * Each module has a container with an unique id
 * To select properly everything, each jquery selection must start with: $(moduleId + " div.example")
 * Module name: map
 * Module id: map-module
 */

 

 /**
 * main.js
 * http://www.codrops.com
 *
 * Licensed under the MIT license.
 * http://www.opensource.org/licenses/mit-license.php
 * 
 * Copyright 2016, Codrops
 * http://www.codrops.com
 */

var prefix = (function () {
    var styles = window.getComputedStyle(document.documentElement, ''),
        pre = (Array.prototype.slice.call(styles).join('').match(/-(moz|webkit|ms)-/) || (styles.OLink === '' && ['', 'o']))[1],
        dom = ('WebKit|Moz|MS|O').match(new RegExp('(' + pre + ')', 'i'))[1];
    return {
        dom: dom,
        lowercase: pre,
        css: '-' + pre + '-',
        js: pre[0].toUpperCase() + pre.substr(1)
    };
})();
// vars & stuff
var support = {transitions : Modernizr.csstransitions},
    transEndEventNames = {'WebkitTransition': 'webkitTransitionEnd', 'MozTransition': 'transitionend', 'OTransition': 'oTransitionEnd', 'msTransition': 'MSTransitionEnd', 'transition': 'transitionend'},
    transEndEventName = transEndEventNames[Modernizr.prefixed('transition')],
    onEndTransition = function(el, callback, propTest) {
        var onEndCallbackFn = function( ev ) {
            if( support.transitions ) {
                if( ev.target != this || propTest && ev.propertyName !== propTest && ev.propertyName !== prefix.css + propTest ) return;
                this.removeEventListener( transEndEventName, onEndCallbackFn );
            }
            if( callback && typeof callback === 'function' ) { callback.call(this); }
        };
        if( support.transitions ) {
            el.addEventListener( transEndEventName, onEndCallbackFn );
        }
        else {
            onEndCallbackFn();
        }
    }
,mall,mallLevelsEl,mallLevels,mallLevelsTotal,mallSurroundings,selectedLevel,mallNav,allLevelsCtrl,levelUpCtrl,levelDownCtrl,pins,contentEl,isNavigating,isExpanded,spaceref,spacesList,openSearchCtrl,containerEl,closeSearchCtrl

var smartbugsStatus = false;
var patientLastInterval = undefined;
var smartbugLastInterval = undefined;
var smartbugs = [];
var groupPositions = [];
var patientPositions = [];
var lastPatientPositions = [];
var animatePatients = [];
var associativeFloors = []; // get the index of floor by its id
var moduleId = "#module-map";
var initSB=false;

function showSmartbugs(showSmartbug=true) {
    if(showSmartbug){
        $("*[class*='smartbug-']").each(function(index){
            $(this).css('display', 'block');
        })
    } else {
        $("*[class*='smartbug-']").each(function(index){
            $(this).css('display', 'none');
        })
        
    }
}

function clearAllInterval() {
    clearInterval(patientLastInterval);
    clearInterval(smartbugLastInterval);
    $(".pin").remove();
    smartbugsStatus = false;
    patientLastInterval = undefined
    smartbugs = [];
    groupPositions = [];
    patientPositions = [];
    animatePatients = [];
}

function startJavascriptMap(endpoint, attachDevicesListeners, attachPatientsListeners, attachGroupsEventListeners, angularScope, token) {
    $.ajaxSetup({headers:{'token': token}});
    config = {endpoint}
    // sending a GET request to backend to retrive floors
    initSB=false;
    $.get(config['endpoint'] + "/floors").then(function(response) {
        initFloors(response);
        // init and update smartbugs status
        $.get(config['endpoint'] + "/locations/smartbugs").then(function(response) {
            retriveSmartBugs(response);
            smartbugLastInterval = setInterval(function(){
                $.get(config['endpoint'] + "/locations/smartbugs").then(function(response) {
                    retriveSmartBugs(response);
                });
            },10000);
        });
        // init and update patients positions status
        $.get(config['endpoint'] + "/locations/patients/last").then(function(response){
            retrivePatientsLastPosition(response);
            patientLastInterval = setInterval(function(){
                $.get(config['endpoint'] + "/locations/patients/last").then(function(response){
                    retrivePatientsLastPosition(response);
                });
            },5000);   
        });

    }).then(function() {
        $(moduleId +' .custom-select-level').on('click',function() {
            showLevel($(this).data('level'));
        });
        $(moduleId +' #all-levels').on('click',function(){ showAllLevels() });
        //$(moduleId +' #up-level').on('click', function(){  showLevel(navigate('Down')) });
        //$(moduleId +' #down-level').on('click',function(){ showLevel(navigate('Up')) });
        setOpacityLevel();
        showPins();
        
    }).catch(e => {
        console.log(e);
        window.location.replace("/pages/login");
    });

   
// START FUNCTION HELPER
    function initFloors(response){
        smartbugs = [];
        groupPositions = [];
        patientPositions = [];
        lastPatientPositions = [];
        animatePatients = [];
        associativeFloors = []; // get the index of floor by its id
        hiddenButtonNavigate();
        showLevelbutton();
        let h= response.data.length*240;
        document.getElementById("mapsContainer").style.height=h+"px";
        var floors = [];//angularScope.floorService.getFloors();
        let res=[]
        for(let i=0; i < response.data.length; i++) {
            res.push(response.data[i]);
        }
        response.data=res;
        for(let i=0; i < response.data.length; i++) {
            if(response.data[i].path == null) {
                response.data[i].path='map2.svg';
            }
            if(!response.data[i].path.includes('.svg')) {
                response.data[i].path='map2.svg';
            }
            response.data[i].path=response.data[i].path.split('/')[response.data[i].path.split('/').length-1];
            associativeFloors[response.data[i].id] = 9-response.data.length+1+i;
            
            floors.push({id:response.data[i].id, image: angularScope.baseUrl+'assets/map-3d/img/'+response.data[i].path, name:response.data[i].name});   
        }

    for(let f=0; f < floors.length; f++) {
        let floor = floors[f];
        $(moduleId + " .levels").append('\
        <div #level-123 class="level level--'+ associativeFloors[floor.id] +'" aria-label="Level '+ floor.id +'" style="top:200px;">\
            <div class="level__name">'+floor.name+'</div>\
            <svg class="map map--'+ floor.id +'" width="100%" height="100%" preserveAspectRatio="xMidYMid meet">\
                <title>Map Level '+ floor.id +'</title> \
                <image x="0" y="0" width="100%" href="'+ floor.image+'" id="floor' + floor.id + '" height="100%" href=""> \
                    <title>Image from db</title> \
                </image> \
            </svg> \
            <div class="level__pins"></div>\
        </div>');
        $(moduleId + ' #button-levels').append('<button class="btn btn-primary mx-1 custom-select-level mapLevelButton" data-level = "'+  Number(f+1) +'" ><span data-i18n="Level">[p'+Number(f+1)+'] '+floor.name+'</span></button>');
    }

        // the mall element
        mall = document.querySelector('.mall'),
        // mall´s levels wrapper
        mallLevelsEl = mall.querySelector('.levels'),
        // mall´s levels
        mallLevels = [].slice.call(mallLevelsEl.querySelectorAll('.level')),
        // total levels
        mallLevelsTotal = mallLevels.length,
        // surroundings elems
        mallSurroundings = [].slice.call(mall.querySelectorAll('.surroundings')),
        // selected level position
        selectedLevel,
        
        // check if currently animating/navigating
        isNavigating,
        // check if all levels are shown or if one level is shown (expanded)
        isExpanded,
        
        // reference to the current shows space (name set in the data-name attr of both the listed spaces and the pins on the map)
        spaceref,
        
        // smaller screens:
        // open search ctrl
        openSearchCtrl = document.querySelector('button.open-search'),
        // main container
        containerEl = document.querySelector('.container'),
        
        // Init Events
        mallLevels.forEach(function(level, pos) {
            level.addEventListener('click', function() {
                // shows this level
            showLevel(pos+1);   //!!!---FIXME: sostituire pos+1 con level.id
            });
        });
        
        showAllLevels();
    }

    function retrivePatientsLastPosition(response){
        patientPositions=[];
        // GESTION CURRENT POSITION
        response.data.forEach(function(patient, index){
            if(patient.floor_id != "" && patient.sb_id != null) {
                if(patientPositions[patient.sb_id] == undefined)
                    patientPositions[patient.sb_id]=[];
                patientPositions[patient.sb_id].push(patient);
            } 
        });
    
        console.log(patientPositions);
        
        // GESTION PIN PATIENT NON PIU' PRESENTI DAL LAST AL CURRENT
        for(var sb_id in lastPatientPositions){
            for(let i=0; i< lastPatientPositions[sb_id].length; i++){ // ciclo per tutti i patients nelle patientPositions
                let patient = lastPatientPositions[sb_id][i];
                console.log("PATIENT: "+patient.patient_id+"\nPOSITIION: ");
                console.log(getPositionPatient(patientPositions,patient.patient_id).sb_id);
                if(getPositionPatient(patientPositions,patient.patient_id).sb_id == null){
                    console.log("REMOVE "+patient.patient_id);
                    removePatienPin(patient,lastPatientPositions);
                }
            }
        }
        // GESTION PIN PATIENT
        for(var sb_id in patientPositions){ // in patientPositions ho per ogni sb_id i patients localizzati in quello smartbug
            for(let i=0; i< patientPositions[sb_id].length; i++){ // ciclo per tutti i patients nelle patientPositions
                let patient = patientPositions[sb_id][i];
                if(getPositionPatient(lastPatientPositions,patient.patient_id).sb_id != getPositionPatient(patientPositions,patient.patient_id).sb_id){ // se non era presente oppure ha cambiato posizione
                    console.log(patientPositions);
                    if(getPositionPatient(lastPatientPositions,patient.patient_id).sb_id == null) {  // primo inserimento non era presente il patient in mappa oppure il patients ha cambiato piano
                        console.log("INSERT "+patient.patient_id);
                        insertPatientPin(patient, patientPositions[sb_id].length);
                    }else{ // aggiorno la posizione perchè il patient ha cambiato smartbug come si deduce dal IF più esterno che controlla la posizione
                        if(getPositionPatient(lastPatientPositions,patient.patient_id).floor_id == getPositionPatient(patientPositions,patient.patient_id).floor_id){ // stesso piano aggiorno il pin patien e la posizione
                            console.log("UPDATE "+patient.patient_id);
                            updatePatientPin(patient,lastPatientPositions);
                        }else{   // il patient ha cambiato piano rimuovo il pin dal piano precedente e inserisco il pin nuovo
                            console.log("UPDATE PIANO "+patient.patient_id);
                            removePatienPin(patient,lastPatientPositions);
                            insertPatientPin(patient);
                        } 
                    }
                } 
            }
        }
        // GESTION PIN GRUPPI
        removeAllPatientGroupPin();  // rimozione icone vecchi gruppi
        for(var sb_id in patientPositions){ // gestione dei gruppi riciclando i patientPositions e vedendo dove ho più patient
            if(patientPositions[sb_id].length > 1){ 
                insertPatientGroupPin(patientPositions[sb_id]); //insert Group Pin
                hiddenPatientsPinForGroup(patientPositions[sb_id]);// hidden patient Pin per il gruppo lo farà con un delay per garantire l animazione
            } else {
                let patientPin = document.getElementsByName("patientpin_"+patientPositions[sb_id][0].patient_id)[0];
                if(patientPin != undefined) patientPin.style.opacity=1;
            }
            
        }

      
        lastPatientPositions = patientPositions;
        attachPatientsListeners(angularScope); // ANGULAR BRIDGES. THOSE METHODS ARE CALLED INSIDE THE TYPESCRIPT
        attachGroupsEventListeners(angularScope); // PASSING THE ANGULAR "THIS" SCOPE AS PARAMETER
    }

    function retriveSmartBugs(response){
        response.data.forEach(function(smartbug){
            let color='';
            let nameSB = '';
            if (smartbug.name==null || smartbug.name == undefined || smartbug.name == ''){
                nameSB = smartbug.sb_id.substr(0,3)+smartbug.sb_id.substr(12)
            } else {
                nameSB = smartbug.name;
            }
            if(smartbug.live) {
                color='blue';
            } else {
                color='red';
            }

            // CORREZIONI MAPPE UFFICIO
            //(smartbug.y_position + ((45 - smartbug.y_position) * 0.24))
            //(smartbug.x_position + ((smartbug.x_position - 52) * 0.42))

            // CORREZIONI MAPPE ENEL
            //(smartbug.y_position + ((47 - smartbug.y_position) * 0.47))
            //(smartbug.x_position + ((smartbug.x_position - 50) * 0.0005))
 
            if(document.getElementById("SB_"+smartbug.sb_id)==null) {
                $(".levels .level--"+associativeFloors[smartbug.room_id]+" .level__pins").append('\
                    <span id="SB_'+smartbug.sb_id+'" class="pin smartbug-pin smartbug-'+smartbug.sb_id+'" data-sb-id=' + smartbug.sb_id + ' style="top: '+ (smartbug.y_position - 1)+ '%; left: '+ (smartbug.x_position - 1) + '%; " iddata-category="1" data-space="'+smartbug.floor_id+'.02">\
                    <label class="pin-label">'+nameSB+'</label>\
                        <span id="SB_'+smartbug.sb_id+'_span" class="pin__icon" style="">\
                            <i id="SB_'+smartbug.sb_id+'_pin" class="nav-icon fas fa-circle smartbug-pin__icon" style=""></i>\
                        </span>\
                    </span>'
                );
            } 
            if(color=="red"){
                document.getElementById("SB_"+smartbug.sb_id+'').style.animation="blinker 1s linear infinite";
                document.getElementById("SB_"+smartbug.sb_id+'_pin').style.color="red";
            } else {
                document.getElementById("SB_"+smartbug.sb_id+'').style.animation="";
                document.getElementById("SB_"+smartbug.sb_id+'_pin').style.color="blue";
            }

            
        });
        // ANGULAR BRIDGE
        // THIS METHOD CONNECTS THIS FILE TO TYPESCRIPT PASSING "THIS" AS "ANGULARSCOPE"
        if(!initSB) {
            attachDevicesListeners(angularScope);
            initSB=true;
        }
            
    }

    function getPositionPatient(positions,patient_id){
        for(sb_id in positions) {
            for(let i=0; i < positions[sb_id].length; i++) {
                if(patient_id == positions[sb_id][i].patient_id)
                    return {sb_id:sb_id, floor_id:positions[sb_id][i].floor_id};
            }
        }
        return {sb_id:null, floor_id:null};
    }

    function insertPatientGroupPin(group){
        var myStyle="";
        if(!$("#all-levels").hasClass("d-none")){myStyle="mystyle";}
        $(".levels .level--"+associativeFloors[group[0].floor_id]+" .level__pins").append('\
        <span id="group_'+ group[0].sb_id +'" class="pin transitions-patients group-pin patientsGroup" data-group-id = "' + group[0].sb_id + '" style="z-index:999999; top: '+ (group[0].y_position) + '%; left: '+ (group[0].x_position) + '%; " data-patient = "patientsGroup" iddata-category="1" data-space="'+associativeFloors[group[0].floor_id]+'.02" >\
            <span class="pin__icon pin__patient '+myStyle+'">\
                <i class="nav-icon green fas fa-users fa-2x text-success"></i>\
                '+ group.length +'\
            </span>\
        </span>');
    }

    function insertPatientPin(patient,numPatients){
        var myStyle="";
        if(!$("#all-levels").hasClass("d-none")){myStyle="mystyle";}
        if(document.getElementsByName("patientpin_"+patient.patient_id).length > 0) {
            console.log("PIN GIA PRESENTE ");
            return;
        }
        $(".levels .level--"+associativeFloors[patient.floor_id]+" .level__pins").append('\
        <span name="patientpin_'+patient.patient_id+'" id="'+patient.patient_id+"_"+patient.sb_id.replace(/:/g,"")+'" class="pin patient-pin transitions-patients patient-'+patient.patient_id+'" style="top: '+ (patient.y_position)+ '%; left: '+ (patient.x_position) + '%; " iddata-category="1" data-space="'+patient.floor_id+'.02" data-sb-id="' + patient.sb_id + '" data-patient="'+patient.patient_id+'"  data-episode="'+patient.episode_id+'" aria-label="'+patient.patient_name+' '+patient.patient_surname+'">\
            <span class="pin__icon pin__patient '+myStyle+'">\
                <div style="margin-left:-30px" >'+patient.patient_name+' '+patient.patient_surname+'</div>\
                <i class="nav-icon fas fa-user" style="color:' +  getPinColor(patient.patient_id) + ';" ></i>\
            </span>\
        </span>');
        let patientPin = document.getElementsByName("patientpin_"+patient.patient_id)[0];
        if(patientPin != undefined) {
            if(numPatients > 1) {
                patientPin.style.opacity = 0;
                //patientPin.style.display = "none";
            } else {
                patientPin.style.opacity = 1;
                //patientPin.style.display = "block";
            }
        }
    }

    function updatePatientPin(patient){
        let patientPin = document.getElementsByName("patientpin_"+patient.patient_id)[0];
        if(patientPin == undefined) return;
        patientPin.style.opacity = 1;
        //patientPin.style.display = "block";
        patientPin.style.top = patient.y_position + '%';
        patientPin.style.left = patient.x_position + '%';
        patientPin.attributes["data-sb-id"].value = patient.sb_id;
        patientPin.attributes["id"].value = patient.patient_id+"_"+patient.sb_id.replace(/:/g,"");
    }

    function removePatienPin(patient, position){
        $("#"+patient.patient_id+"_"+getPositionPatient(position,patient.patient_id).sb_id.replace(/:/g,"")).remove();
    }

    function removeAllPatientGroupPin(){
        var groupPins = $(moduleId + ' .patientsGroup');
        groupPins.remove();
    }

    function hiddenPatientsPinForGroup(patiens_ids){
        for(let i=0; i<patiens_ids.length; i++){
            let patient = patiens_ids[i];
            let patientPin = document.getElementsByName("patientpin_"+patient.patient_id)[0];
            if(patientPin != undefined) {
                setTimeout(()=>{ 
                    console.log("NASCONDO "+patient.patient_id);
                    patientPin.style.opacity = 0;
                    //patientPin.style.display = "none";
                },1500);
            }  
        }
    }

    function showLevel(level) {
        if( isExpanded ) {
            return false;
        }
        removeOpacityLevel();
        hiddenLevelbutton();
        // update selected level val
        selectedLevel = level;

        
        classie.add(mallLevelsEl, 'levels--selected-' + selectedLevel);
        // the level element
        var levelEl = mallLevels[selectedLevel - 1];
        classie.add(levelEl, 'level--current');
        onEndTransition(levelEl, function() {
            classie.add(mallLevelsEl, 'levels--open');

            
            var a = document.getElementsByClassName("pin__patient");
            for(i=0;i<a.length;i++){
                //a[i].setAttribute("style", "-webkit-transform: rotate3d(8,4,-1,69deg);"); 
                a[i].classList.add("mystyle");
            }
            
            // aggiunto per enel non mostra i livelli che creano interferenza
            for(var i=0; i < mallLevels.length; i++) {
                if(i != selectedLevel - 1){
                    classie.add(mallLevels[i], 'levels--display--none');
                } 
            }

            // show level pins
            showPins();
            isExpanded = true;
            showButtonNavigate();
        }, 'transform');
        
        // hide surroundings element
        hideSurroundings();
    }

    function showAllLevels() {
        if( isNavigating || !isExpanded ) {
            return false;
        }
        isExpanded = false;

        classie.remove(mallLevels[selectedLevel - 1], 'level--current');
        classie.remove(mallLevelsEl, 'levels--selected-' + selectedLevel);
        classie.remove(mallLevelsEl, 'levels--open');

        
        var a = document.getElementsByClassName("pin__patient");
        for(i=0;i<a.length;i++){
            //a[i].setAttribute("style", "-webkit-transform: rotate3d(0,0,0,0deg);"); 
            a[i].classList.remove("mystyle");
        }
        

        for(var i=0; i < mallLevels.length; i++) {
                classie.remove(mallLevels[i], 'levels--display--none');
        }
        // hide level pins
        //removePins();

        // shows surrounding element
        setOpacityLevel();
        showSurroundings();
        showLevelbutton();
        hiddenButtonNavigate();
    }

    function showPins(levelEl) {
    //  var levelEl = levelEl || mallLevels[selectedLevel - 1];
    //  classie.add(levelEl.querySelector('.level__pins'), 'level__pins--active');
    $('.level__pins').addClass('level__pins--active');
    }

    function showSurroundings() {
        mallSurroundings.forEach(function(el) {
            classie.remove(el, 'surroundings--hidden');
        });
    }

    function hideSurroundings() {
        mallSurroundings.forEach(function(el) {
            classie.add(el, 'surroundings--hidden');
        });
    }

    function hiddenButtonNavigate() {
        $('#all-levels').addClass('d-none');
        $('#up-level').addClass('d-none');
        $('#down-level').addClass('d-none');
    }

    function showButtonNavigate() {
        $('#all-levels').removeClass('d-none');
        $('#up-level').removeClass('d-none');
        $('#down-level').removeClass('d-none');
    }

    function showLevelbutton() {
        $('#button-levels').removeClass('d-none');
    }

    function hiddenLevelbutton() {
        $('#button-levels').addClass('d-none');
    }

    function setOpacityLevel(){
        $('.map').addClass('opacity-level');
    }

    function removeOpacityLevel(){
        $('.map').removeClass('opacity-level');
    }

    function getPinColor(state) {
        state = ""+state;
        state = Number(state.charAt(state.length-1));
        var patientColor = ''
        if       (state == 1) {
            patientColor = '#f60b0b'; // rosso
        } else if(state == 2) {
            patientColor = '#75f60b'; // verde
        } else if(state == 3) {
            patientColor = '#ffcf3f'; // giallo
        } else if(state == 4) {
            patientColor = '#ff5513'; // arancio
        } else if(state == 5) {
            patientColor = '#f813ff;'; // viola
        } else if(state == 6) {
            patientColor = '#13deff'; // azzurro
        } else if(state == 7) {
            patientColor = '#1343ff'; // blu
        } else if(state == 8) {
            patientColor = '#ffa8c8'; // rosa
        } else if(state == 9) {
            patientColor = '#ff00bf'; // lilla
        } else if(state == 0) {
            patientColor = '#191919'; // nero
        }
        return patientColor;
    }

    function navigate(direction) {
        if( isNavigating || !isExpanded ) {
            return false;
        }
        isNavigating = true;

        var prevSelectedLevel = selectedLevel;

        // current level
        var currentLevel = mallLevels[prevSelectedLevel-1];

        if( direction === 'Up' && prevSelectedLevel > 1 ) {
            --selectedLevel;
        }
        else if( direction === 'Down' && prevSelectedLevel < mallLevelsTotal ) {
            ++selectedLevel;
        }
        else {
            isNavigating = false;	
            return false;
        }

        
        // transition direction class
        classie.add(currentLevel, 'level--moveOut' + direction);
        // next level element
        var nextLevel = mallLevels[selectedLevel-1]
        // ..becomes the current one
        classie.add(nextLevel, 'level--current');

        // when the transition ends..
        onEndTransition(currentLevel, function() {
            classie.remove(currentLevel, 'level--moveOut' + direction);
            // solves rendering bug for the SVG opacity-fill property
            setTimeout(function() {classie.remove(currentLevel, 'level--current');}, 60);

            classie.remove(mallLevelsEl, 'levels--selected-' + prevSelectedLevel);
            classie.add(mallLevelsEl, 'levels--selected-' + selectedLevel);

            // show the current level´s pins
            showPins();

            isNavigating = false;
        });

        // filter the spaces for this level
        //showLevelSpaces();

        // hide the previous level´s pins
        //removePins(currentLevel);
    }

}